import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { store } from './redux/store';

// Define a custom backend for i18next
const customBackend = {
  read: function (language, namespace, callback) {
    // Construct the S3 URL
    const url = `https://eachperson-asset-images.s3.eu-west-1.amazonaws.com/accounts-ui/i18n/${language}.json`;

    fetch(url)
      .then(response => response.json())
      .then(data => callback(null, data))
      .catch(error => callback(error, false));
  }
};

// Initialize i18next
i18n
  .use({ type: 'backend', init: () => {}, read: customBackend.read }) // Use custom backend
  .use(initReactI18next) // Connect with React
  .init({
    backend: {
      read: customBackend.read,
    },
    fallbackLng: 'en_GB',
    debug: true,
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    keySeparator: false, // Disable key separator for flat JSON
  });

// Function to change language dynamically
export const changeLanguage = (langCode) => {
  i18n.changeLanguage(langCode);
};

export default i18n;